module.exports = __webpack_public_path__ + "img/game_2.290b94ca.jpg";